export default __webpack_public_path__ + "static/media/avinash.5e965603.png";